export default __webpack_public_path__ + "static/media/08_photo.f786b1e5.jpg";